import React, { useEffect } from "react";
import { Tabel, DropDown, Badge, DropDownMenu, Modal } from "../core";
import { reducer, initialState } from "../hooks/modalReducer";
// import { Link } from "react-router-dom";
import { Menu, 
  
  // Form 

} from "antd";
import { useSelector, useDispatch } from "react-redux";
// import EmptyBeamDeliver from "./EmptyBeamDeliver";
import DeleteModal from "../components/DeleteModal";
// import BeamReceived from "./BeamReceived";
import { deleteAddProgram } from "../redux/Action/Sizer/addProgram";
import { programHistory } from "../redux/Action/Sizer/addProgram";
import { getCompanyId } from "../helper/utils/companyId";
import { useSizerData } from "../hooks/useSizerData";
const Notify_Utils = require("../helper/utils/Notification");

const invoice = [
  {
    title: "SR #",
    dataIndex: "SNo",
    render: (text, record, index) => {
      return <span>{index + 1}</span>;
    },
    key: "S.No",
    width: 150,
  },
  {
    title: "Sizer Name",
    dataIndex: "sizer_name",
    key: "sizer_name",
    width: 150,
  },
  {
    title: "Quality",
    dataIndex: "quality",
    key: "quality",
    render: (text, record, index) => {
      return (
        <span>
          {record.count}/{record.con_size}/{record.brand}/{record.type}
        </span>
      );
    },
    width: 150,
  },
  {
    title: "Tar/BackBeam",
    dataIndex: "tarbackbeam",
    key: "tarbackbeam",
    render: (text, record, index) => {
      return (
        <span>
          {record.tar}/{record.back_beam}
        </span>
      );
    },
    width: 150,
  },
  {
    title: "Empty Beam Delivery",
    dataIndex: "empty_beam_delivery",
    key: "empty_beam_delivery",
    render: (text, record, index) => {
      return (
        <Badge
          status={
            record.beam_delivered === true ? "Delivered" : "Not Delivered"
          }
          text={record.beam_delivered === true ? "Delivered" : "Not Delivered"}
        ></Badge>
      );
    },

    width: 150,
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (text, record) => (
      <Badge
        status={record.program_status}
        text={record.program_status}
      ></Badge>
    ),
    width: 150,
  },
  {
    title: "",
    dataIndex: "action",
    width: 150,
    render: (text, record, index) => (
      <DropDown
        overlay={<MenuCompo index={index} record={record} />}
        record={record}
      />
    ),
  },
];

const ProgramHistory = ({ pagination, ...props }) => {
  useSizerData();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.auth);
  const ProgramHistoryData = useSelector((state) => state.addProgam.addProgram);

  useEffect(() => {
    const companyId = getCompanyId();
    if (companyId && token && (!ProgramHistoryData || !ProgramHistoryData.length)) {
      dispatch(programHistory(companyId, token));
    }
  }, [dispatch, token, ProgramHistoryData]);

  if (!ProgramHistoryData) {
    return <div>Loading...</div>;
  }
  return (
    <Tabel
      {...props}
      rowKey={({ payment_id }) => payment_id}
      padding="0px"
      pagination={pagination}
      columns={invoice}
      data={ProgramHistoryData}
    />
  );
};

const MenuCompo = (params) => {
  const dispatchtoAction = useDispatch();
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const [AddProgramId, setAddProgramId] = React.useState(null);
  const { token } = useSelector((state) => state.auth);

  const company_id = getCompanyId();
  const onCreate = () => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };
  const onCancel = () => {
    dispatch({ type: "MODAL_VIEW", payload: false });
  };
  let Error = useSelector((state) => state.errorReducer);

  console.log(AddProgramId);
  const delete_func = () => {
    console.log(AddProgramId);
    dispatchtoAction(deleteAddProgram(AddProgramId.id, company_id, token));
    onCancel();
  };

  function menuClickHandler({ item, key }) {
    setAddProgramId({ id: item.props.id });
    return key === "delete_add_program"
      ? dispatch({
          type: "MODAL_VIEW",
          payload: { flag: true, modal_name: key },
        })
      : key === "edit"
      ? dispatch({
          type: "MODAL_VIEW",
          payload: { flag: true, modal_name: key },
        })
      : null;
  }
  // const [form] = Form.useForm();
  const { record } = params;
  console.log("record", record);
  return (
    <>
      {Error.id === "PROGRAM_DELETE_FAIL" ? (
        Object.values(Error.msg).map((items, index) => {
          return Notify_Utils.openNotificationWithIcon(
            "error",
            `${items[0]}`,
            "white"
          );
        })
      ) : Error.id === "PROGRAM_DELETE_SUCCESS" ? (
        <>{Notify_Utils.openNotificationWithIcon("success", Error.msg)}</>
      ) : null}
      {state.modal_name === "delete_add_program" ? (
        <Modal
          closable={true}
          footer={false}
          visible={state.visible}
          maxwidth="550px"
          tittle="Are You Sure you want to delete this record"
        >
          <DeleteModal
            id_to_delete={AddProgramId}
            onCancel={onCancel}
            delete_func={delete_func}
          />
        </Modal>
      ) : state.modal_name === "edit" ? (
        <Modal
          closable={true}
          footer={false}
          visible={state.visible}
          onCreate={onCreate}
          tittle=" Update Profile Info"
        >
          {/* <EditForm
            AddProgramId={AddProgramId}
            onCreate={onCreate}
            onCancel={onCancel}
            form={form}
          /> */}
        </Modal>
      ) : null}
      <DropDownMenu onClick={menuClickHandler}>
        <Menu.Item
          key="delete_add_program"
          id={record.add_program_id}
          color="blue"
        >
          Delete
        </Menu.Item>
        {/* <Menu.Item key="view">
          <Link
            to={{
              pathname: `/buyer-inner/${record.buyer_company_name}`,
              state: record,
            }}
          >
            View
          </Link>
        </Menu.Item> */}
        <Menu.Item key={`edit`} id={record.add_program_id}>
          Edit
        </Menu.Item>
      </DropDownMenu>
    </>
  );
};
export default ProgramHistory;
